import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '../@types/store';

export type AppDispatch = ThunkDispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
